export const markdown_faq_13_1 = `Nel caso in cui un'attività sia condivisa tra più utenti, può rivelarsi utile bloccare momentaneamente l'accesso agli altri utenti. Questo consente di eliminare il rischio di modifiche contemporanee e quindi sovrascrizione di dati.

**COME BLOCCARE UN'ATTIVITÀ**
Nella stringa dell'attività selezionare l'icona del lucchetto.
Gli altri utenti non potranno accedere in modifica e sapranno che è stata bloccata da te. 
Una volta terminato il tuo lavoro ricordati di sbloccarla cliccando nuovamente sull'icona del lucchetto.`;
